import React, {useContext, useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Dialog, Item, Button} from '@zebra-fed/zds-react-desktop';
import {SnackbarContent} from "../../styled-components/shared";
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Snackbar from '@material-ui/core/Snackbar';
import '@zebra-fed/icons/Alert/index.css';
import {useTranslation} from "react-i18next";
import {MessageResponseContext} from "../../data/MessageLocalizationProvider";
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CSVImport from '../../pages/CsvImport';
import ModifyPage from '../../pages/ModifyPage';
import CircularProgress from "@material-ui/core/CircularProgress";

const CheckboxComp = styled.div`
    display: flex;
    align-items: center;
    margin-left: -8px;
    font-size: 20px;
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  align-items: inital;
  padding: 20px 20px;
`;

const ButtonContainer = styled.div`
    display: flex;
    max-width: 500px;
    justify-content: end;
`;

export default function DevicesManageAMDModal(props) {
    const { onContinue =()=>{}, importType, isLoadingCsv } = props;
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [addedNoteValue, setAddedNoteValue] = useState("")
    const serverMessage = useRef('');
    const [importMethod, setImportMethod] = useState('UPLOAD_CSV'); // manual or csv
    const [radioOpts] = useState(
        {
            'ADD':{
                name: t('csvModal.Manual'),
                value: 'MANUAL'
            },
            // 'MODIFY': {
            //     name: 'Search',
            //     value: 'SEARCH'
            // },
            // 'DELETE': {
            //     name: 'Search',
            //     value: 'SEARCH'
            // }

        }
    )
    const [accessInclude, setAccessInclude] = useState(false)
    const [isImportTypeSelected, setIsImportTypeSelected] = useState(false)
    const [currStep, setCurrStep] = useState(0)

    // useEffect(()=>{
    //     clearNote &&  setAddedNoteValue("") ;
    // }, [clearNote])

    // useEffect(()=>{
    //     setAddedNoteValue(noteValue)
    // },[noteValue])


    // function handleTextareaChange(e) {
    //     setAddedNoteValue(e.target.value)
    // }

    function handleCancel() {
        dialogRef.current.toggleDialog();
        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }



    const handleChange = (event) => {
        setImportMethod(event.target.value);
      };

    const onClickContinueBtn =() => {
        // setIsImportTypeSelected(true)
        // setCurrStep(currStep+1)
        onContinue({
            'importMethod': importMethod,
            'accessInclude': accessInclude,
            'type':importType?.name
        })
        dialogRef.current.toggleDialog();
    }  

    return (
        <div className='import-modal'>
            <Dialog 
                ref={dialogRef}
                key='dialog2'
                width='520px'            
               headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px', width: '100%'}}
                cardStyle={{ marginBottom: '80px'}}
                // style={{cursor: isLoading ? 'wait' : 'default'}}
                >
                {/* <ModalHeader>
                   {importType?.name}
                </ModalHeader> */}
                <MainContent
                 style={{ cursor: isLoadingCsv ? "wait" : "default", opacity: isLoadingCsv ? '0.4' : '1' }}
                
                >
                    {/* { !isImportTypeSelected  ?  
                        <span> */}
                            <h4 style={{margin: '0px'}}>{importType?.name}</h4>
                            <p style={{marginTop: '0px'}}>{t('csvModal.Description')}</p>
                            <RadioGroup aria-label="gender" name="gender1" value={importMethod} onChange={handleChange}>
                                {importType?.value === 'ADD' && <FormControlLabel value={radioOpts[importType?.value]?.value} control={<Radio  />} label={radioOpts[importType?.value]?.name} /> }
                                <FormControlLabel value="UPLOAD_CSV" control={<Radio />} label={t('csvModal.UploadCsv')} />
                            </RadioGroup>

                            {/* <CheckboxComp>
                            <Checkbox
                                    checked={accessInclude}
                                    onChange={(e) => setAccessInclude(e.target.checked)}
                                />
                                <p style={{fontSize: '12px'}}>Inclue Access Points</p>
                            </CheckboxComp> */}
                            <ButtonContainer>
                                    <Button
                                        onClick={() => handleCancel()}
                                        type="primary"
                                        style={{ marginLeft: '0px', background: 'white', color: 'black', border: '2px solid gray' }}
                                    >
                                        {t('cancel')}
                                    </Button>
                                    <Button
                                        onClick={()=>onClickContinueBtn()}
                                        type="primary"
                                        style={{ marginLeft: '0px' }}
                                        disabled={isLoadingCsv}
                                    >
                                        {t('continue')}
                                        {/* {currStep === 0 ? 'Continue' : currStep === 1 ? 'Confirm'} */}
                                    </Button>
                         </ButtonContainer>
                        {/* </span>
                        :
                        importMethod === 'UPLOAD_CSV' ? 

                        <CSVImport myRef = {dialogRef}  />
                        :
                        <ModifyPage /> 
                        
                    } */}
                      {/* <ButtonContainer>
                                    <Button
                                        onClick={() => handleCancel()}
                                        type="primary"
                                        style={{ marginLeft: '0px', background: 'white', color: 'black', border: '2px solid gray' }}
                                    >
                                        {t('cancel')}
                                    </Button>
                                    <Button
                                        onClick={()=>onClickContinueBtn()}
                                        type="primary"
                                        style={{ marginLeft: '0px' }}
                                    >
                                        {t('continue')}
                                        {currStep === 0 ? 'Continue' : currStep === 1 ? 'Confirm'}
                                    </Button>
                         </ButtonContainer> */}
                </MainContent>
                {isLoadingCsv && <div style={{ textAlign: 'center', width: '100%', position: 'absolute', top: '43%' }}>
                <CircularProgress />
            </div>}
                {/* <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                    <SnackbarContent error={true}>{serverMessage.current}</SnackbarContent>
                </Snackbar> */}
            </Dialog>
        </div>
    )
}